import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { createProvider, Step } from '../../../../shared/IFE/step/step/step';
import { UntypedFormBuilder } from '@angular/forms';
import { TechnicalDetailsSteps } from './models/technical-details-steps';
import { MetaSteps } from '../../models/constants';
import { EvcApiService } from '../../../../shared/modules/evc-api/services/evc-api.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from '../../../../shared/modules/analytics/services/analytics.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'evc-quote-technical-details',
  providers: [createProvider(TechnicalDetailsComponent)],
  templateUrl: './technical-details.component.html',
  styleUrls: ['./technical-details.component.scss'],
})
export class TechnicalDetailsComponent extends Step implements OnInit {
  @Input() activeStep: TechnicalDetailsSteps | MetaSteps = TechnicalDetailsSteps.intro;
  @Input() email: string;
  @Input() id: string;
  @Output() stepNavigation: EventEmitter<string> = new EventEmitter<string>();
  previousScreen: string;

  readonly technicalDetailsSteps = TechnicalDetailsSteps;
  readonly formName = 'evcQuote';
  readonly stepName = 'technical-details';

  constructor(
    fb: UntypedFormBuilder,
    analyticsService: AnalyticsService,
    private api: EvcApiService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    super(fb, analyticsService);
  }

  ngOnInit(): void {
    this.buildForm();

    // If we have no active Step we set to the first step
    this.activeStep = this.activeStep === MetaSteps.first ? TechnicalDetailsSteps.intro : this.activeStep;

    // If the activeStep contains the last metadata we set the last step active.
    this.activeStep = this.activeStep === MetaSteps.last ? TechnicalDetailsSteps.trajectory : this.activeStep;
  }

  goToStep(step: TechnicalDetailsSteps) {
    this.stepNavigation.emit(step);
    this.activeStep = step;
  }

  continueLater(e: string) {
    this.previousScreen = e;
    this.api
      .continueLater(this.id)
      .pipe(
        finalize(() => {
          this.activeStep = TechnicalDetailsSteps.continueLater;
        })
      )
      .subscribe(
        () => {
          this.toastr.success(this.translate.instant('messages.emailSend'));
        },
        () => {
          this.toastr.error(this.translate.instant('errorMessages.serverError'));
        }
      );
  }

  protected buildForm() {
    this.control = this.fb.group({
      fuseBox: [],
      electricPhase: [],
      amperage: [],
      mainFuse: [],
      placement: [],
      distance: [],
      trajectory: [],
    });

    this.control.valueChanges.subscribe(() => {
      this.onModelChange(this.control.value);
      this.onTouch();
    });
  }
}
